import { toast } from 'react-toastify';

export default class NotificationService {
  private registration: ServiceWorkerRegistration | undefined = undefined;
  private isPermissionGranted: boolean = false;

  constructor() {
    if (NotificationService.browserSupportsServiceWorkers()) {
      navigator.serviceWorker.ready.then((registration) => {
        this.registration = registration;
      });
    }
  }

  private static browserSupportsServiceWorkers(): boolean {
    return 'serviceWorker' in navigator;
  }

  private static browserSupportsNotifications(): boolean {
    return 'Notification' in window;
  }

  // https://developer.mozilla.org/en-US/docs/Web/API/Notifications_API/Using_the_Notifications_API#Requesting_permission
  private static checkNotificationPromise() {
    try {
      Notification.requestPermission().then();
    } catch (e) {
      return false;
    }

    return true;
  }

  private handlePermission(permission: string): void {
    this.isPermissionGranted = permission === 'granted';
  }

  public requestPermission(): void {
    if (!NotificationService.browserSupportsNotifications()) return;

    if (Notification.permission === 'granted') {
      this.isPermissionGranted = true;
    } else if (NotificationService.checkNotificationPromise()) {
      Notification.requestPermission().then((permission) => {
        this.handlePermission(permission);
      });
    } else {
      const self = this;

      Notification.requestPermission(function (permission) {
        self.handlePermission(permission);
      });
    }
  }

  public send(message: string): void {
    if (this.isPermissionGranted && typeof this.registration !== 'undefined') {
      this.registration
        .showNotification('VisIT Notification', {
          body: message,
          icon: '/Capadm40.ico',
        })
        .then();
    } else {
      toast.info(message);
    }
  }
}
